import React, { useEffect, useState } from 'react';
import 'bootstrap-select';
import { useSelector } from 'react-redux';
import RunnerEngineService from 'service/RunnerEngineService';
import { Link } from 'react-router-dom';
import TabNavigation from 'component/TabNavigator';
import CustomDropdown from 'component/CustomDropdown';
import { PageSizeOption } from 'domain/constant/PageSizeOption';

const RunnerEngine: React.FC = () => {

  const { profile } = useSelector((state: any) => state.auth);
  const [data, setData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tabMode, setTabMode] = useState<string>('data');

  const tabs = [
    { key: "data", label: "Data" },
    { key: "history", label: "History" }
  ] as const;

  const runnerEngineService = RunnerEngineService()

  const fetchData = async () => {
    const token = profile?.data.token;
    if (!token) return;

    setLoading(true);
    try {
      let res;

      if (tabMode === 'data') {
        res = await runnerEngineService.runnerEngineList(
          token, currentPage, pageSize, searchTerm
        );
      } else {
        res = await runnerEngineService.runnerEngineHistoryList(
          token, currentPage, pageSize, searchTerm
        );
      }

      setData(res.data ?? []);
      setTotalPages(res.pagination?.totalPage ?? 0);
      setTotalRecords(res.pagination?.totalRecords ?? 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    setCurrentPage(1);
    fetchData();
  }, [tabMode]);

  const handleSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setCurrentPage(1);
    fetchData();
  };

  const handleExecute = async (executionId: string) => {
    const token = profile?.data?.token;
    if (!token) return;

    try {
      setLoading(true);
      const res = await runnerEngineService.runnerEngineExecute(token, executionId);
      alert("Runner executed successfully!");

      fetchData();
    } catch (err) {
      alert("Error: " + err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="row">
        <div className="col-12">
          <div className="d-flex">
            <h5 style={{ flex: 1 }}>Runner Engine</h5>
            <div>
              <p>TransMore Runner Engine</p>
            </div>
          </div>
        </div>
        <div className="col-12">

          <div className="p-4" style={{ background: 'white' }}>

            <div className="d-flex mb-3">
              <TabNavigation
                activeTab={tabMode}
                onTabChange={(tab) => {
                  setTabMode(tab);
                  setCurrentPage(1);
                }}
                tabs={[
                  { key: "data", label: "Data" },
                  { key: "history", label: "History" }
                ]}
              />
            </div>


            {tabMode === "data" &&
              <div className="d-flex mb-3">

                <form className="d-flex" onSubmit={handleSearchClick}>
                  <input
                    type="text"
                    className="form-control form-control-compact me-2"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button type="submit" className="btn btn-primary px-4">
                    <i className="fa-solid fa-search"></i>
                  </button>
                </form>

                <div className="d-flex justify-content-end" style={{ flex: 1 }}>
                  <Link to="/runner-engine/0" className='float-end text-decoration-none tm-text-primary'>
                    <button className="btn btn-primary">
                      <span className="me-2">
                        New Runner
                      </span>
                      <i className="fa-solid fa-plus"></i>
                    </button>
                  </Link>
                </div>
              </div>
            }

            <table className="table table-condensed table-hover">
              <thead className="table-primary">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  {tabMode === "data" && <th>Created At</th>}
                  {tabMode === "data" && <th>Created By</th>}
                  <th>Last Run At</th>
                  <th>Last Run By</th>
                  {tabMode === "data" && <th></th>}
                </tr>
              </thead>
              <tbody>
                {
                  !loading ?
                    data.length > 0 ? (
                      data.map((item) => (
                        <tr key={item.executionId}>
                          <td>{item.runnerCode}</td>
                          <td>{item.reportName}</td>
                          {tabMode === "data" && <td>{item.createdAt}</td>}
                          {tabMode === "data" && <td>{item.createdBy}</td>}
                          <td>{item.runAt}</td>
                          <td>{item.runBy}</td>
                          {tabMode === "data" &&
                            <td>
                              <div className="d-flex">
                                <button className="btn btn-outline-success btn-small-compact border-0"
                                  onClick={() => handleExecute(item.executionId)}>
                                  <i className="fa-solid fa-play-circle"></i>
                                </button>
                                <Link to={'/runner-engine/' + item.executionId}>
                                  <button className="btn btn-outline-warning btn-small-compact border-0 ms-2">
                                    <i className="fa-solid fa-edit"></i>
                                  </button>
                                </Link>
                                <button className="btn btn-outline-danger btn-small-compact border-0 ms-2">
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          }
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )
                    :
                    <tr>
                      <td colSpan={10} className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
            <div className="d-flex justify-content-end align-items-center mt-3">
              <div className="d-flex align-items-center">
                <div className="me-4 d-flex align-items-center">
                  <label className="me-2">Rows per page:</label>
                  <CustomDropdown
                    value={pageSize}
                    options={PageSizeOption.options}
                    onChange={(opt) => {
                      setPageSize(Number(opt.id));
                      setCurrentPage(1);
                      fetchData();
                    }}
                    align="top"
                  />
                </div>
                <span className="me-3">
                  {`${(currentPage - 1) * pageSize + 1}–${Math.min(currentPage * pageSize, totalRecords)} of ${totalRecords}`}
                </span>

                <nav>
                  <ul className="pagination mb-0">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>

                    <li className="page-item disabled">
                      <span className="page-link" style={{ border: 0 }}>{currentPage}</span>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} style={{ border: 0 }}>
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(totalPages)} style={{ border: 0 }}>
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );

};

export default RunnerEngine;